/* Code by convx - 985. Sub-category rail, rollout of A/B test #706 (V2).
 * Tiles are plain links rendered by snippets/cvx-category-rail.liquid.
 * This only drives the desktop arrows and stops the "All" tile reloading
 * the page it is already on. */
(function () {
  'use strict';

  function init(rail) {
    var list = rail.querySelector('.cvx-rail--list');
    var arrows = rail.querySelectorAll('.cvx-rail--arrow');
    if (!list) return;

    function syncArrows() {
      var max = list.scrollWidth - list.clientWidth;
      for (var i = 0; i < arrows.length; i++) {
        var prev = arrows[i].getAttribute('data-cvx-rail-dir') === 'prev';
        var atEnd = prev ? list.scrollLeft <= 2 : list.scrollLeft >= max - 2;
        arrows[i].hidden = max <= 4 || atEnd;
      }
    }

    for (var i = 0; i < arrows.length; i++) {
      arrows[i].addEventListener('click', function () {
        var dir = this.getAttribute('data-cvx-rail-dir') === 'prev' ? -1 : 1;
        list.scrollBy({ left: dir * Math.round(list.clientWidth * 0.8), behavior: 'smooth' });
      });
    }
    list.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    rail.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-cvx-rail-current]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
    });
  }

  function start() {
    var rails = document.querySelectorAll('.cvx-rail');
    for (var i = 0; i < rails.length; i++) init(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
